import React, { useEffect, useState } from "react";
import { FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetCategory } from "../redux/slices/GetCategorySlice";
import { FiArrowRight } from "react-icons/fi";

const CategorySection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeCategoryId, setActiveCategoryId] = useState(null);
  const { AllCategory } = useSelector((state) => state.category);
  const [startIndex, setStartIndex] = useState(0);
  const itemsPerPage = 4;
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    dispatch(GetCategory());
  }, [dispatch]);

  const handleCategoryClick = (category) => {
    setActiveCategory((prev) =>
      prev === category?.name ? null : category?.name
    );
    setActiveCategoryId(category?._id);
  };

  const handleViewAllCategories = () => {
    navigate("/all-cate");
  };

  const visibleCategories = AllCategory.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handleNext = () => {
    if (startIndex + itemsPerPage < AllCategory.length) {
      setStartIndex(startIndex + itemsPerPage);
    }
  };

  const handlePrevious = () => {
    if (startIndex - itemsPerPage >= 0) {
      setStartIndex(startIndex - itemsPerPage);
    }
  };

  const _handleClick = (name, subcategory) => {
    localStorage.setItem("SubCategoryName", subcategory?.name);
    navigate(
      `/ShowSubCategory/${name?.name}/${subcategory?.name}/${name?._id}`,
      {
        state: {
          name: name?.name,
          activeCategoryId,
          activeCategory,
          SubCategoryName: subcategory?.name,
        },
      }
    );
    setActiveCategory("null");
  };

  const category = AllCategory?.find(
    (category) => category.name === activeCategory
  );

  useEffect(() => {
    if (activeCategory && category?.subcategories?.length === 0) {
      setShowModal(true);
    }
  }, [category, activeCategory]);

  return (
    <>
      <div className=" w-[95%] flex justify-end mt-1 ">
        <button
          onClick={handleViewAllCategories}
          className="sm:hidden block text-blue-500 font-medium text-sm sm:text-base flex items-center mb-1"
        >
          View All
          <FaChevronRight className="ml-2" />
        </button>
      </div>
      <div className="flex justify-center items-center z-50 self-center ">
        <div className="flex gap-3 sm:gap-3 overflow-x-auto w-full self-center justify-center items-center">
          <div className="w-[90%] self-center items-center justify-center flex pb-3 bg-gray-50">
            <div className="sm:hidden  flex flex-col w-[100%] bg-gray-100 relative">
              <h1 className="text-black m-2 font-bold">Categories</h1>
              <div className="flex flex-row  items-center justify-center ">
                {startIndex > 0 && (
                  <button
                    onClick={handlePrevious}
                    className="z-10 fixed  flex absolute left-[-13px] h-20 w-10 justify-center items-center"
                  >
                    <button className="  text-blue-500 font-medium text-sm flex items-center h-8 w-8 rounded-full justify-center bg-gray-300">
                      <FaChevronRight className="rotate-180" />
                    </button>
                  </button>
                )}

                {visibleCategories?.map((category, index) => (
                  <div
                    key={index}
                    className="relative flex flex-col items-center cursor-pointer  w-96 overflow-hidden"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCategoryClick(category);
                    }}
                  >
                    <img
                      loading="lazy"
                      src={category.image}
                      alt={category.name}
                      className="w-14 h-14 rounded-full object-cover mb-2"
                    />
                    <button className="text-black font-medium hover:text-red-700 text-sm sm:text-base whitespace-nowrap overflow-hidden text-ellipsis  w-[95%]">
                      {category.name}
                    </button>
                  </div>
                ))}

                {startIndex + itemsPerPage < AllCategory.length && (
                  <button
                    className="absolute right-[-13px] text-blue-500 font-medium text-sm flex items-center  h-8 w-8 rounded-full justify-center bg-gray-300"
                    onClick={handleNext}
                  >
                    <FaChevronRight />
                  </button>
                )}
              </div>
            </div>
            <div className=" hidden sm:flex flex-row overflow-x-auto gap-10 items-center bg-transparent p-3 mt-2">
              {AllCategory?.slice(0, 7).map((category, index) => (
                <div
                  key={index}
                  className="relative flex flex-col items-center cursor-pointer mt-3"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCategoryClick(category);
                  }}
                >
                  <img
                    loading="lazy"
                    src={category.image}
                    alt={category.name}
                    className="w-12 h-12 rounded-full object-cover mb-2"
                  />
                  <button
                    className="text-black font-medium hover:text-red-700 text-sm sm:text-base 
                  whitespace-nowrap overflow-hidden text-ellipsis"
                  >
                    {category.name}
                  </button>
                </div>
              ))}
              {/* <div className="flex justify-between items-center w-[90%] mx-auto hidden sm:flex">
                <h2 className="text-lg font-semibold"></h2>
                <button
                  onClick={handleViewAllCategories}
                  className="flex  text-blue-500 font-medium text-sm sm:text-base items-center"
                >
                  View All
                  <FaChevronRight className="ml-2" />
                </button>
              </div> */}
              <div className="w-[90%] mx-auto hidden sm:flex justify-between items-center py-2">
                <button
                  onClick={handleViewAllCategories}
                  className="flex items-center justify-center w-20 h-20 rounded-full bg-blue-100 hover:bg-blue-200 shadow-md transition-all duration-300"
                  title="View All"
                >
                  <div className="flex flex-col items-center text-blue-600">
                    <FaChevronRight className="text-lg mb-1" />
                    <span className="text-xs font-medium">View All</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="flex justify-between items-center w-[90%] mx-auto hidden sm:flex">
        <h2 className="text-lg font-semibold"></h2>
        <button
          onClick={handleViewAllCategories}
          className="flex  text-blue-500 font-medium text-sm sm:text-base items-center"
        >
          View All
          <FaChevronRight className="ml-2" />
        </button>
      </div> */}

      {activeCategory && category?.subcategories?.length > 0 && (
        <div className="flex justify-center items-center py-0 z-50 self-center">
          <div className="flex gap-3 sm:gap-3 overflow-x-auto w-full self-center justify-center items-center">
            <div className="w-[90%] self-center items-center justify-center flex from-gray-200 to-white bg-gray-100">
              <div>
                <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-6 py-2 mt-2 sm:mt-0 sm:mb-0 mb-2 justify-between">
                  {category?.subcategories?.length > 0
                    ? category?.subcategories.map((subcategory, subIndex) => (
                        <div
                          onClick={() => {
                            _handleClick(category, subcategory);
                          }}
                          key={subIndex}
                          className="text-center"
                        >
                          <img
                            loading="lazy"
                            src={subcategory.image}
                            alt={subcategory.name}
                            className="w-14 h-14 mx-auto rounded-full object-cover hover:scale-105 transition-transform mt-1"
                          />
                          <p className="text-sm font-medium text-gray-700 mb-3">
                            {subcategory?.name}
                          </p>
                        </div>
                      ))
                    : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg p-6 w-[300px] text-center shadow-lg">
            <h2 className="text-xl font-bold mb-2">Coming Soon</h2>
            <p className="text-gray-600 mb-4">
              Products for this category will be available soon
            </p>
            <button
              onClick={() => setShowModal(false)}
              className="mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CategorySection;
